import React from "react";
import { messageSet } from "../../redux/actions/messageActions";
import { SchemaUploadV3 } from "../ConfigSchema/SchemaUploadV3";
import { fetchData } from "../../_lib/lib";
import { BackButton } from "../../components/AtomComponents";
interface IProps {
  syncFor: string;
}

const ManualUploadV3 = ({ syncFor }: IProps) => {
  return (
    <>
      <div className="cell small-6 medium-6 px-one-line-data">
        <BackButton />
        <h3 className="small-12 margin-bottom-1">Upload Queries V3</h3>
      </div>
      <SchemaUploadV3 syncFor={syncFor} messagesSet={messageSet} />
    </>
  );
};

export default ManualUploadV3;

export const manualSchemaUploadV3 = async (
  fileState: any,
  release: any,
  syncFor: string,
  type?: string,
  tenantid?: string
) => {
  return await fetchData(
    "post",
    `schema-sync${syncFor !== "master" ? "-slave" : ""}/manual-upload-v3`,
    {
      body: fileState,
      header: {
        release,
        type,
        tenantid: type === "TransactionPerTenant" ? tenantid : null,
      },
    },
    true
  );
};
